import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_NEW_PETITION_PAGE_REMOVE_RFS_EXPERIMENT = createFcmDetails(
	'new_petition_page_remove_rfs_experiment',
	{
		owner: 'Capybara Squad',
		context: 'Petition Details',
		import: false,
		description: `
		Determines whether the remove reason-for-signing field experiment is active.

		Also specifies the name of the experiment, so this FCM can be used to reset which experiment we check.
	`,
		template: {
			experimentName: 'remove_rfs_experiment',
		},
	},
);
